const translation = {
  custom: 'Настройка',
  upgradeTip: {
    prefix: 'Обновите свой тарифный план, чтобы',
    suffix: 'настроить свой бренд.',
    des: 'Обновите свой план, чтобы настроить свой бренд',
    title: 'Обновите свой план',
  },
  webapp: {
    title: 'Настроить бренд веб-приложения',
    removeBrand: 'Удалить Powered by Dify',
    changeLogo: 'Изменить изображение бренда Powered by',
    changeLogoTip: 'Формат SVG или PNG с минимальным размером 40x40px',
  },
  app: {
    title: 'Настроить бренд заголовка приложения',
    changeLogoTip: 'Формат SVG или PNG с минимальным размером 80x80px',
  },
  upload: 'Загрузить',
  uploading: 'Загрузка',
  uploadedFail: 'Ошибка загрузки изображения, пожалуйста изображение, загрузите еще раз.',
  change: 'Изменить',
  apply: 'Применить',
  restore: 'Восстановить значения по умолчанию',
  customize: {
    contactUs: ' свяжитесь с нами ',
    prefix: 'Чтобы настроить логотип бренда в приложении, пожалуйста,',
    suffix: 'чтобы перейти на корпоративную версию.',
  },
}

export default translation
